import {Fancybox} from "@fancyapps/ui/src/Fancybox/Fancybox.js"
import cs from "@fancyapps/ui/src/Fancybox/l10n/cs"
import {Swiper} from "swiper/types"

interface SwiperElement extends HTMLElement {
  swiper?: Swiper
}

const gallery = document.querySelectorAll<HTMLElement>(".s-faq, .s-gallery-intro")

gallery.forEach((section) => {
  const gallerySlider = section.querySelector<SwiperElement>(".g-gallery-slider__large-img .g-gallery-slider")

  if (!gallerySlider) return

  const galleryId = section?.querySelector("a.i-gallery-slide__link")?.getAttribute("data-fancybox-block")

  const preloadAllThumbnails = () => {
    if (window.lazyloading?.loadAll) {
      window.lazyloading.loadAll()
    }
  }

  const fancyboxSettings = {
    id: galleryId,
    l10n: cs,
    groupAll: true,
    Image: {
      zoom: false,
    },
    Toolbar: {
      display: ["close"],
    },
    on: {
      shouldClose: function () {
        const activeItem = document.querySelector(".is-nav-selected")
        const atributte = Number(activeItem?.getAttribute("data-index"))
        gallerySlider.swiper?.slideTo(atributte, 0)
      },
    },
  }

  Fancybox.bind(`.i-gallery-slide__link[data-fancybox-block=${galleryId}]`, fancyboxSettings)

  const galleryLinks = section.querySelectorAll(`.i-gallery-slide__link[data-fancybox-block=${galleryId}]`)
  galleryLinks.forEach((link) => {
    link.addEventListener("click", () => {
      preloadAllThumbnails()
    })
  })
})
